import React from 'react';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import { Box, FDAlert, Stack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import WizardSubtitleText from 'Views/Page/Content/Modal/Layouts/DefaultStep/Layout/WizardSubtitleText';

const PageContentTop = ({
  badgeImage,
  badgeImageAlt,
  subtitle,
  title,
  alertTitle,
  alertDescription,
  titleTest = 'wizard-step-title',
  subtitleTest = 'wizard-step-subtitle',
  resource,
  textAlign,
}) => {
  let subtitles = null;

  if (subtitle && resource && resource?.meta()?.field('subtitle').attr('hint') === 'richtext') {
    subtitles = <RichTextDisplay content={subtitle} />;
  } else if (subtitle) {
    subtitles = <WizardSubtitleText textAlign={textAlign} value={subtitle} subtitleTest={subtitleTest} />;
  }

  return <>
    <Stack direction={'column'} spacing={2} alignItems={'center'} justifyContent="flex-start">
      {badgeImage && (
      <Box width={72} height={72}>
        <img style={{ width: '100%', height: '100%', objectFit: 'contain' }} src={badgeImage} alt={badgeImageAlt} />
      </Box>
      )}
      {title && <Title align={textAlign} value={title} test={titleTest} />}
      {subtitle && (subtitles)}
      {alertTitle && alertDescription && <FDAlert status="info" title={alertTitle} description={alertDescription} />}
    </Stack>
  </>;
};

PageContentTop.defaultProps = {
  badgeImage: undefined,
  badgeImageAlt: undefined,
  subtitle: undefined,
  title: undefined,
  alertTitle: undefined,
  alertDescription: undefined,
  titleTest: undefined,
  subtitleTest: undefined,
  resource: undefined,
  textAlign: 'center',
};

PageContentTop.propTypes = {
  badgeImage: PropTypes.string,
  badgeImageAlt: PropTypes.string,
  subtitle: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
  title: PropTypes.string,
  alertTitle: PropTypes.string,
  alertDescription: PropTypes.string,
  titleTest: PropTypes.string,
  subtitleTest: PropTypes.string,
  resource: PropTypes.object,
  textAlign: PropTypes.oneOf(['left', 'center']),
};

export default PageContentTop;
